export const automatedEmailTypes = {
  insurance_submitted: {
    text: 'Insured Certificate Submission Confirmation Email',
    tooltip: 'When an agent submits a certificate, PINS sends this email to notify the insured that the certificate has successfully been submitted'
  },
  agent_updated_policy: {
    text: 'Agent Updated Policy Email',
    tooltip: 'When an agent updates a policy they previously submitted, PINS sends this email to the PINS Users who are watching the associated record.'
  },
  updated_agent_policy: {
    text: 'PINS User Updated Agent Policy Email',
    tooltip: 'In a PINS User updates an agent\'s policy, PINS sends this email to notify the agent that their submission has been altered'
  },
  insurance_request_verification: {
    text: 'Insurance Request Verification Email',
    tooltip: 'If an agent chooses to verify their email for the certificate submission process, PINS sends this email to verify that they are the owner of the email address.'
  },
  user_tagged_in_comment: {
    text: 'Comment Tag Email',
    tooltip: 'If a user is tagged in a comment, PINS sends this email to notify that user.'
  },
  insurance_submission_failure: {
    text: 'Insurance Submission Failure Email',
    tooltip: 'If the agent\'s certificate submission fails for some reason, PINS sends this email to notify of the failure.'
  },
  watcher_cert_submitted: {
    text: 'PINS User Certificate Submission Confirmation Email',
    tooltip: 'When an agent submits a certificate, PINS sends this email to notify PINS Users '
      + '(project owner, department owner, company owner, and/or record watchers) that the certificate has successfully been submitted'
  },
  agent_cert_submitted: {
    text: 'Agent Certificate Submission Confirmation Email',
    tooltip: 'When an agent submits a certificate, PINS sends this email to notify the Agent that the certificate has successfully been submitted'
  }
};
